<script>
  import TwInput from '../tailwind/TwInput.svelte';
  import TwSelectMenu from '../tailwind/TwSelectMenu.svelte';
  import TwRadioGroup from '../tailwind/TwRadioGroup.svelte';

  export let value;
  export let fields;
  export let lang = undefined;
</script>

<div class='admin-fields'>
  {#each fields as field}
    <div class='admin-fields-field'>
      {#if field.input === 'input'}
        {#if field.name.includes('.')}
          {@const primaryKey = field.name.split('.')[0]}
          {@const secondaryKey = field.name.split('.')[1]}

          <TwInput bind:value={value[primaryKey][secondaryKey]} label={field.label[lang]} placeholder={field.placeholder} note={field.note} link={field.link}/>
        {:else}
          <TwInput bind:value={value[field.name]} label={field.label[lang]} placeholder={field.placeholder} note={field.note} link={field.link}/>
        {/if}
      {:else if field.input === 'select-menu'}
        {#if field.name.includes('.')}
          {@const primaryKey = field.name.split('.')[0]}
          {@const secondaryKey = field.name.split('.')[1]}

          <TwSelectMenu bind:value={value[primaryKey][secondaryKey]} label={field.label[lang]} elements={field.elements}/>
        {:else}
          <TwSelectMenu bind:value={value[field.name]} label={field.label[lang]} elements={field.elements}/>
        {/if}
      {:else if field.input === 'radio-group'}
        {#if field.name.includes('.')}
          {@const primaryKey = field.name.split('.')[0]}
          {@const secondaryKey = field.name.split('.')[1]}

          <TwRadioGroup bind:value={value[primaryKey][secondaryKey]} label={field.label[lang]} elements={field.elements} note={field.note} link={field.link}/>
        {:else}
          <TwRadioGroup bind:value={value[field.name]} label={field.label[lang]} elements={field.elements} note={field.note} link={field.link}/>
        {/if}
      {/if}
    </div>
  {/each}
</div>

<style>
  .admin-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    width: calc(100% - 104px);
  }

  .admin-fields-field {
    flex-grow: 1;

    width: calc((100% - 10px) / 2);
  }

  @media only screen and (max-width: 640px) {
    .admin-fields-field {
      width: 100%;
    }
  }
</style>
